// extracted by mini-css-extract-plugin
module.exports = {"search-form__input":"FacetSearch_search-form__input__SNg9O","search-form__icon":"FacetSearch_search-form__icon__1N7_i","search-form__field":"FacetSearch_search-form__field__OjSRg"};